(() => {
 document.querySelectorAll('[data-studio-entry]').forEach(root => {
  const start=root.querySelector('[data-studio-start]');
  const url=new URL(start.href);const params=new URLSearchParams(location.search);
  for(const key of ['bb_edit','preview_theme_id','variant'])if(params.has(key))url.searchParams.set(key,params.get(key));
  start.href=url.href;
  // Existing basket edit links go directly to the same spacious editor.
  if(params.has('bb_edit')){location.replace(url.href);return;}
  const image=root.querySelector('.bb-studio-product-art img');
  root.querySelectorAll('[data-studio-image]').forEach(button=>button.addEventListener('click',()=>{
   image.src=button.dataset.studioImage;image.removeAttribute('srcset');
   root.querySelectorAll('[data-studio-image]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));
  }));
 });
})();
